import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';

export const getFormSchema = (selectsOptions: SelectsOptions, mode?: CrudMode | null): FormItem[] => [
  {
    title: 'global.labels.category',
    name: 'category',
    valueType: 'select',
    formItemProps: {
      rules: [{ required: true }],
    },
    fieldProps: {
      options: selectsOptions[FieldType.NOTE_CATEGORY],
    },
  },
  {
    title: 'global.labels.note',
    name: 'text',
    valueType: 'textarea',
    formItemProps: {
      rules: [{ required: true }],
    },
  },
];
